/**
 * src/components/admin/AdminLayout.js
 * 
 * Shared layout wrapper for all admin pages.
 * Desktop: sidebar + main content panel
 * Mobile: top nav + full-width content
 */

import React from "react";
import { Outlet } from "react-router-dom";
import AdminNav from "./AdminNav";

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-950">
      <div className="flex min-h-screen">
        {/* Sidebar (desktop) */}
        <AdminNav />

        {/* Main content */}
        <div className="flex-1 min-w-0 flex flex-col">
          <main className="flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
